// extracted by mini-css-extract-plugin
module.exports =  {"lti-activity":"Lti-omRj__lti-activity","activity-title":"Lti-qjiV__activity-title","provider-title":"Lti-LSQ9__provider-title"};